<template>
    <div class="sidebar product-filter-sidebar">
        <div class="filter" v-show="!this.hideClear">
            <h4><a @click.prevent="clearFilters" href="" class="color-brown">Clear selected filters <i class="fas fa-times"></i></a></h4>
        </div>
        <div class="filter">
            <h4>Price</h4>
            <vue-slider
                :tooltip="'always'"
                :tooltip-placement="'top'"
                :data="filters.price"
                :interval="0.01"
                :enable-cross="false"
                v-model="priceRange"
                @drag-end="changePrice"
            >
            </vue-slider>
        </div>
        <div class="filter" v-for="(filter, filterName) in this.filters" v-if="filterName != 'price'">
            <h4 @click="toggleFilter(filterName)">{{ filterName }} <i :class="'fas fa-chevron-'+( openFilters.includes(filterName) ? 'up' : 'down' )"></i></h4>
            <div class="checkboxes" v-show="openFilters.includes(filterName)">
                <b-form-checkbox-group
                    v-model="selected[filterName]"
                    name="filters"
                    :options=" ( filterName == 'region' && regions.length > 0 ? regions : filter ) "
                >
                </b-form-checkbox-group>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'

    export default {
        name: "ProductFilters",
        components: {
            VueSlider
        },
        props: {
            filtersarray: Object
        },
        data: function() {
            return {
                filters: {
                    price: [0,100]
                },
                regions: [],
                priceRange: [Math.min(...this.filtersarray.price), Math.max(...this.filtersarray.price)],
                openFilters: [],
                selected: {},
                price: [],
                hideClear: true
            }
        },
        mounted() {
            for( var filter in this.filtersarray ) {
                if ( filter == 'price' ) {
                    this.filters.price = this.filtersarray.price.sort(function(a,b) { return a - b;});
                    this.priceRange[0] = Math.min(...this.filters.price)
                    this.priceRange[1] = Math.max(...this.filters.price)
                } else {
                    this.filters[filter] = this.filtersarray[filter];
                }
            }

            this.price = this.priceRange;

            this.$root.$on('constrainRegions', data => {
                this.regions = data;
            });

            if( ( Math.floor(Date.now()/1000) - localStorage.updatedTime ) < 3600  && ( this.$root.productAttributes.length == 0 && this.$root.productCat.length == 0 ) ) {
                if(localStorage.filters) {
                    this.selected = JSON.parse(localStorage.filters);
                    this.$root.$emit('productFilter', this.selected);
                    this.$root.$emit('productsChangePage', [1, true]);
                }

                if(localStorage.regions)
                    this.regions = JSON.parse(localStorage.regions)

                if(localStorage.priceRange)
                    this.priceRange = JSON.parse(localStorage.priceRange)

                if(localStorage.openFilters)
                    this.openFilters = JSON.parse(localStorage.openFilters)
            }

            if(this.$root.productCat.length > 0) {
                this.openFilters.push('Category')
                Vue.set(this.selected, 'Category', [])
                this.selected.Category.push(this.$root.productCat.replace('-', ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}))
            }

            for ( var attribute in this.$root.productAttributes ) {
                if ( this.$root.productAttributes[attribute].length > 0 ) {
                    this.openFilters.push(attribute.replace('pa_', ''))
                    Vue.set(this.selected, attribute.replace('pa_', ''), [ this.$root.productAttributes[attribute]
                        .replace('-', ' ')
                        .replace(/\w\S*/g, function(txt) {
                            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        }) ])
                }
            }

        },
        watch: {
            selected: {
                handler(filters) {
                    if ( this.$root.productCat.length == 0 )
                        localStorage.filters = JSON.stringify(filters);

                    this.localStorageUpdate();

                    for ( var k in filters )
                        if ( filters[k] && filters[k].length > 0 )
                            this.hideClear = false

                    if( Object.keys(filters).length == 0 )
                        localStorage.removeItem(filters)

                    this.$root.$emit('productFilter', filters);
                    this.$root.$emit('productsChangePage', [1, true]);
                },
                deep: true
            },
            regions: function(regions) {
                if ( this.$root.productCat.length == 0 )
                    localStorage.regions = JSON.stringify(regions)
            },
            priceRange: function(priceRange) {
                if ( this.$root.productCat.length == 0 )
                    localStorage.priceRange = JSON.stringify(priceRange)
            },
            openFilters: function (openFilters) {
                if ( this.$root.productCat.length == 0 )
                    localStorage.openFilters = JSON.stringify(openFilters)
            }
        },
        methods: {
            clearFilters: function() {
                this.selected = {
                    Category: []
                };
                this.priceRange = this.price;
                this.hideClear = true;
            },
            changePrice: function() {
                this.hideClear = false;
                this.$root.$emit('productsPriceRange', this.priceRange);
                this.$root.$emit('productsChangePage', [1, true]);
            },
            toggleFilter: function(filterName) {
                if(this.openFilters.includes(filterName))
                    this.openFilters = this.openFilters.filter( e => { return e !== filterName } );
                else
                    this.openFilters.push(filterName);
            },
            displayFilter: function(name, value) {
                if( name != 'region' ) return true;
                if( this.regions.length == 0 ) return true;
                else if( this.regions.includes(value) ) return true;
                return false
            },
            localStorageUpdate: function() {
                localStorage.updatedTime = Math.floor( Date.now() / 1000 );
            }
        }
    }
</script>